import { io } from 'socket.io-client'
import { me } from 'store/me'
import { MosaicSocket } from 'store/socket/event'
import { delay } from 'util/promise'

class SocketController {
  ws!: string
  socket?: MosaicSocket
  private usages = 0

  use() {
    ++this.usages
    if (this.usages === 1) this.open()
  }

  unuse() {
    --this.usages
    if (this.usages === 0) this.close()
  }

  private open() {
    const { ws } = this
    const { user_id } = me

    this.close()

    const url = `${ws}/${user_id}`
    this.socket = io(url, {
      autoConnect: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      transports: ['websocket', 'polling'],
      withCredentials: true,
    })

    this.socket.connect()
    // this.socket.on('connect', () => console.info('socket connect'))
    // this.socket.on('disconnect', (reason: string) => console.info('socket disconnect', reason))
    this.socket.on('error', (error: Error) => console.error('socket error', error))
    this.socket.on('reconnect_error', (error: Error) => console.error('reconnect error', error))
    this.socket.on('reconnect_failed', () => console.error('reconnect failed'))
    this.socket.on('connect_error', async (error: Error) => {
      console.error('connect error', error)
      const socket = this.socket
      if (!socket || socket?.active) return

      await delay(10000)
      if (socket === this.socket) socket?.connect()
    })
  }

  private close(): void {
    this.socket?.close()
    this.socket = undefined
  }
}

export const socket = new SocketController()
